import React from 'react';
import './AppLayout.less';
import logo from '../../assets/logo-full.png';
import slogan from '../../assets/slogan.png';
import {Button, Modal, Space, Spin, Tooltip} from 'antd';
import {UserAddOutlined} from '@ant-design/icons';
import {useHistory} from 'react-router-dom';
import useAuth from '../../utils/AuthContext';
import useCheckAuth from '../../hooks/useCheckAuth';
import {useBoolean} from 'react-hanger';
import LoginForm from '../user/LoginForm';
export default function AppHeader() {
  const history = useHistory();
  const auth = useAuth();
  const checkAuth = useCheckAuth();
  const isLogin = useBoolean(false);
  return (
    <div className={'AppHeader'}>
      <div className={'AppHeaderTitle'}>
        <img src={logo} style={{width: 350}} alt="" />
        <img src={slogan} style={{height: 28}} alt="" />
        {!checkAuth.isChecking && (
          <Space className={'AppHeaderTitle-Btn'}>
            {!auth.currentUser && (
              <Button type={'primary'} ghost onClick={isLogin.setTrue}>
                登录
              </Button>
            )}
            {(auth.currentUser?.isSu || auth.currentUser?.isManager) && (
              <Button type={'primary'} ghost onClick={() => history.push('/manage/article')}>
                进入管理后台
              </Button>
            )}
            {!auth.currentUser?.personalApprove && !auth.currentUser?.isSu && !auth.currentUser?.isManager && (
              <Button href={'/#/about/register'} type={'primary'} icon={<UserAddOutlined />}>
                在线入会
              </Button>
            )}
            {!!auth.currentUser?.personalApprove && (
              <Button href={'/#/profile/detail'} type={'primary'} icon={<UserAddOutlined />}>
                个人信息
              </Button>
            )}
            {!!auth.currentUser && (
              <Button
                danger
                ghost
                onClick={() => {
                  auth.logout();
                  localStorage.removeItem('Application-Token');
                }}>
                退出登录
              </Button>
            )}
          </Space>
        )}
      </div>
      <div className={'AppNavBarWrapper'}>
        <div className={'AppNavBar'}>
          <div className={'AppNavItem'} onClick={() => history.push('/')}>
            首页
          </div>
          <div className={'AppNavItem'} onClick={() => history.push('/about/introduction')}>
            关于 SCS
          </div>
          <div className={'AppNavItem'} onClick={() => history.push('/workCommittee/学术工作委员会')}>
            工作委员会
          </div>
          <div className={'AppNavItem'} onClick={() => history.push('/specialtyCommittee/人工智能专业委员会')}>
            专业委员会
          </div>
          <div className={'AppNavItem'} onClick={() => history.push('/activity/summarize')}>
            会议活动
          </div>
          <div className={'AppNavItem'} onClick={() => window.open('https://iai.sh.cn')}>
            竞赛平台
          </div>
        </div>
      </div>
      <Modal visible={isLogin.value} onCancel={isLogin.setFalse} footer={null}>
        <div className={'p-b-10'}>
          <LoginForm onClose={isLogin.setFalse} />
        </div>
      </Modal>
    </div>
  );
}
